import _ArrowForward from "@mui/icons-material/ArrowForward";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import styled from 'styled-components';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import { Button } from '@mui/material';
import { LinkOnComponent } from 'app/components/links/link';
import { SkeletonPlaceholderDataContainer, SkeletonPlaceholderOverlay, SkeletonPlaceholderWrapper } from 'app/styles/districtModules/SkeletonPlaceholderStyles';
const DataContainer = styled(SkeletonPlaceholderDataContainer).withConfig({
  componentId: "sc-1m6gd0m-0"
})(["padding:", ";gap:", ";display:flex;flex-direction:column;justify-content:space-between;align-items:center;", ";", ";"], SIZES['16'], SIZES['16'], props => props.theme.streamLayoutOneColBig(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", ";\n    gap: ", ";\n  "])), SIZES['36'], SIZES['36']), props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: ", ";\n    gap: ", ";\n  "])), SIZES['56'], SIZES['36']));
const StyledTypography = styled(Typography).withConfig({
  componentId: "sc-1m6gd0m-1"
})(["text-align:center;", ";", ";"], props => props.theme.streamLayoutOneColBig(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), SIZES['16']), props => props.theme.desktopLayout(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), SIZES['16']));
export default function ModulePlaceholder(_ref) {
  let {
    text,
    buttonText,
    link,
    linkRel = 'nofollow',
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(SkeletonPlaceholderWrapper, {
    "data-sentry-element": "SkeletonPlaceholderWrapper",
    "data-sentry-component": "ModulePlaceholder",
    "data-sentry-source-file": "ModulePlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(SkeletonPlaceholderOverlay, {
    "data-sentry-element": "SkeletonPlaceholderOverlay",
    "data-sentry-source-file": "ModulePlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(DataContainer, {
    "data-sentry-element": "DataContainer",
    "data-sentry-source-file": "ModulePlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(StyledTypography, {
    variant: "body2",
    "data-sentry-element": "StyledTypography",
    "data-sentry-source-file": "ModulePlaceholder.tsx"
  }, text), /*#__PURE__*/React.createElement(LinkOnComponent, {
    to: link,
    rel: linkRel,
    "data-sentry-element": "LinkOnComponent",
    "data-sentry-source-file": "ModulePlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "inherit",
    sx: {
      color: COLORS.fupaSecondary,
      backgroundColor: COLORS.lightestGrey
    },
    endIcon: /*#__PURE__*/React.createElement(_ArrowForward, null),
    "data-sentry-element": "Button",
    "data-sentry-source-file": "ModulePlaceholder.tsx"
  }, buttonText)))), children);
}